'use client'

import { useEffect, useRef, useState } from 'react'

const SliderArrow = ({ direction, disabled = false }: { direction: 'right' | 'left'; disabled: boolean }) => (
  <svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    fill="none"
    transform={direction === 'right' ? 'rotate(0)' : 'rotate(180)'}>
    <circle cx={20} cy={20.5} r={19.5} fill="white" stroke="#989898" />
    <path
      d="M18.582 26.8838L24.2139 21.252C24.6294 20.8364 24.6294 20.1627 24.2139 19.7472L18.582 14.1154"
      stroke={disabled ? '#989898' : '#A82137'}
      strokeWidth={3.54679}
      strokeLinecap="round"
    />
  </svg>
)

function HorizontalScroll({ children }: { children: React.ReactNode }) {
  const scorllRef = useRef<HTMLDivElement | null>(null)

  const [scrollX, setscrollX] = useState(0)
  const [scrolEnd, setscrolEnd] = useState(false)

  const slide = (shift: number) => {
    if (!scorllRef.current) {
      return
    }

    scorllRef.current.scrollLeft += shift
    setscrollX(scrollX + shift) // Updates the latest scrolled postion

    //For checking if the scroll has ended
    if (Math.floor(scorllRef.current.scrollWidth - scorllRef.current.scrollLeft) <= scorllRef.current.offsetWidth) {
      setscrolEnd(true)
    } else {
      setscrolEnd(false)
    }
  }

  const scrollCheck = () => {
    if (!scorllRef.current) {
      return
    }
    setscrollX(scorllRef.current.scrollLeft)
    if (Math.floor(scorllRef.current.scrollWidth - scorllRef.current.scrollLeft) <= scorllRef.current.offsetWidth) {
      setscrolEnd(true)
    } else {
      setscrolEnd(false)
    }
  }

  useEffect(() => {
    //Check width of the scollings
    if (scorllRef.current && scorllRef?.current?.scrollWidth === scorllRef?.current?.offsetWidth) {
      setscrolEnd(true)
    } else {
      setscrolEnd(false)
    }
  }, [scorllRef])

  // console.log({
  //   scrollX,
  //   scrolEnd,
  //   scrollWidth: scorllRef?.current?.scrollWidth,
  //   offsetWidth: scorllRef?.current?.offsetWidth,
  //   end: Math.floor(scorllRef?.current?.scrollWidth - scorllRef?.current?.scrollLeft),
  // })

  return (
    <div className="mb-6 mt-12 flex flex-row">
      <div className="flex w-10 items-center">
        <button
          className="prev"
          onClick={() => {
            if (scrollX !== 0) slide(-300)
          }}>
          <SliderArrow direction="left" disabled={scrollX === 0} />
        </button>
      </div>
      <div
        ref={scorllRef}
        onScroll={scrollCheck}
        className="scrollbar-hide max-w-[100%] snap-x overflow-x-scroll scroll-smooth">
        <div className="inline-flex whitespace-nowrap">
          {children} <div className="w-5" />
        </div>
      </div>
      <div className="flex w-10 items-center">
        <button
          className="next"
          onClick={() => {
            if (!scrolEnd) slide(+300)
          }}>
          <SliderArrow direction="right" disabled={!!scrolEnd} />
        </button>
      </div>
    </div>
  )
}

export default HorizontalScroll
